
export class SignUpInfo {
    constructor (
        public schoolName: string,
        public adminEmail: string,
        public confirmAdminEmail: string,
        public adminName: string,
        public phoneNumber: string,
        public password: string
    ) {
    }
}
